import styled from '../../../../../../styles/styledComponents/themeComponents';

export const EventWidgetListTableStyle = styled.div`
  .ReactTable {
    overflow-x: scroll;
  }
`;
export const EventWidgetListTableHeader = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
`;
